import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { UserFacade } from '@app/core/app-services';

@Injectable({
  providedIn: 'root'
})
export class AgeVerifiedGuard implements CanActivate {

  constructor(private userFacade: UserFacade) { }

  canActivate(): Observable<boolean> {
    return this.userFacade.ageOK();
  }
}
